import React from 'react';
import MediaDropzone from '../MediaDropzone/MediaDropzone';

/**
 * Einzelbild-Upload — API kompatibel mit bestehenden Admin-Dialogen.
 */
const ImageUpload = ({
  onUploadComplete,
  onUploadError,
  type = 'default',
  name = 'Image',
  maxSizeMB = 64,
  currentImage = null,
  label = 'Bild hierher ziehen oder klicken',
}) => {
  return (
    <MediaDropzone
      multiple={false}
      label={label}
      type={type}
      name={name}
      maxSizeMB={maxSizeMB}
      value={currentImage}
      onChange={(uploaded) => {
        if (uploaded) onUploadComplete?.(uploaded);
      }}
      onClear={() => onUploadComplete?.({ id: null, image: null, cleared: true })}
      onError={onUploadError}
    />
  );
};

export default ImageUpload;
